import localforage from 'localforage'

export default (ctx, inject) => {
  const store = localforage.createInstance({
    name: 'JBS',
    version: 1.0,
  })
  ctx.$localforage = store
  ctx.app.$localforage = store
  inject('localforage', store)
}
